module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 70
    }
  }, [(_vm.professions.length) ? _c('CardtabLayout', _vm._l((_vm.professions), function(profession, index) {
    return _c('ItemSingle', _vm._b({
      key: index
    }, 'ItemSingle', profession, false))
  }), 1) : (!_vm.error) ? _c('AppHeading', {
    attrs: {
      "level": "2",
      "mod": "bold, center, uppercase"
    }
  }, [_vm._v("Программ нет")]) : _c('AppHeading', {
    attrs: {
      "level": "2",
      "mod": "bold, center, uppercase, red"
    }
  }, [_vm._v("Сбой в работе оборудования")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d3801b8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/professions/card/program/Program.vue
// module id = 83d4a97e22baa370232e
// module chunks = 67